/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from "react";

function Wip() {
  return (
    <div className="tabs-container">
      <div className="container-fluid h-100 d-flex flex-column justify-content-between py-3">
        <div className="row banner-section" id="banner-section">
          <div className="image-responsive">
            <img src="/images/state_banner.jpg" alt="Welcome to CMdS-Rebates" />
          </div>
          <div className="banner-text">
            <div className="large-text">Work in progress</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Wip;
